import {useEffect} from "react";
import {useNavigate} from "react-router-dom"
import useAuth from "../hooks/useAuth";
import {redirectAuth} from "../routes/web";

const Authenticate = ({ children }) => {
    const navigate = useNavigate();
    const { isAuthenticated, loading } = useAuth();

    useEffect(() => {
        if (!loading && !isAuthenticated) {
            navigate(redirectAuth);
        }
    }, [navigate, isAuthenticated, loading]);

    // Hiển thị loading khi đang kiểm tra authentication
    if (loading) {
        return <div>Loading...</div>;
    }

    // Chỉ render children khi đã authenticated
    if (!isAuthenticated) {
        return null;
    }

    return (
        <>
            {children}
        </>
    );
}

export default Authenticate;
